/**
 * Meta Pixel — código base oficial.
 * Se inicializa una sola vez por carga de página y dispara un único PageView.
 * Los eventos adicionales (Lead, Contact, etc.) se configurarán más adelante.
 */

export const META_PIXEL_ID = '2433320707143614'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
    __inkovaMetaPixelReady?: boolean
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  // Evita inicializaciones o PageView duplicados (re-render, hot reload, StrictMode).
  if (window.__inkovaMetaPixelReady) return
  window.__inkovaMetaPixelReady = true

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const w = window as any

  if (!w.fbq) {
    const n: any = function (...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args)
      } else {
        n.queue.push(args)
      }
    }
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    w.fbq = n
    if (!w._fbq) w._fbq = n

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }
  }

  w.fbq('init', META_PIXEL_ID)
  w.fbq('track', 'PageView')
  /* eslint-enable @typescript-eslint/no-explicit-any */

  listenForWhatsAppClicks()
}

function track(event: 'Lead' | 'Contact'): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  window.fbq('track', event)
}

/** Lead: solo tras una respuesta exitosa de Formspree. */
export function trackLead(): void {
  track('Lead')
}

/**
 * Contact: un único listener delegado detecta el clic en cualquier enlace cuyo
 * destino sea WhatsApp (hero, header, servicios, botón flotante, cierre y el CTA
 * posterior al formulario), sin tocar los componentes ni retrasar la apertura.
 */
function listenForWhatsAppClicks(): void {
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target
      if (!(target instanceof Element)) return

      const link = target.closest('a[href]')
      if (!link) return

      const href = link.getAttribute('href') ?? ''
      if (!/(?:wa\.me|api\.whatsapp\.com|web\.whatsapp\.com|whatsapp:)/i.test(href)) return

      track('Contact')
    },
    { capture: true, passive: true },
  )
}
